import { render, staticRenderFns } from "./Adpage.vue?vue&type=template&id=57d4e28c&scoped=true"
import script from "./Adpage.vue?vue&type=script&lang=js"
export * from "./Adpage.vue?vue&type=script&lang=js"
import style0 from "./Adpage.vue?vue&type=style&index=0&id=57d4e28c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d4e28c",
  null
  
)

export default component.exports